import React from 'react';
import { Checkbox, Tag } from 'antd';
import './AuthorizationWidget.css';

/**
 * AuthorizationWidget - Pure display component for authorization requirements
 * Receives pre-parsed security requirements data from useOpenApiParser
 *
 * @param {Array} securityRequirements - Parsed security requirements from parseSecurityRequirements()
 */
const AuthorizationWidget = ({ securityRequirements }) => {
  // Only render if there are security requirements
  if (!securityRequirements || securityRequirements.length === 0) {
    return null;
  }

  return (
    <div className="authorization-widget">
      <div className="authorization-header">
        <h3 className="authorization-title">Authorisation</h3>
      </div>

      <div className="authorization-content">
        {securityRequirements.map((requirement, index) => (
          <React.Fragment key={index}>
            <div className="authorization-row">
              <div className="authorization-checkbox-wrapper">
                <Checkbox disabled checked>
                  {requirement.parameterName || requirement.name}
                </Checkbox>
              </div>

              <div className="authorization-tags">
                {/* Display type tag */}
                {requirement.type && (
                  <Tag className="authorization-tag-default">
                    {requirement.type === 'http' && requirement.scheme ? requirement.scheme : requirement.type}
                  </Tag>
                )}

                {/* Display location tag (in) */}
                {requirement.in && <Tag className="authorization-tag-default">{requirement.in}</Tag>}

                {/* Always show required tag for security requirements */}
                <Tag className="authorization-tag-required">required</Tag>
              </div>
            </div>

            {/* Display description if available */}
            {requirement.description && <p className="authorization-description">{requirement.description}</p>}

            {/* Display scopes if present (for OAuth2) */}
            {requirement.scopes && requirement.scopes.length > 0 && (
              <div className="authorization-scopes">
                <span className="authorization-scopes-label">Scopes: </span>
                {requirement.scopes.join(', ')}
              </div>
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default AuthorizationWidget;
